import React, { useState } from 'react'
import { Spinner, Stack } from 'react-bootstrap'
import { Link, useLocation } from 'react-router-dom'

import styled from 'styled-components'

import { useTitle } from '@lib/web'
import { DataPackages } from '@piv/lib/rest-queries'
import * as Routes from '@piv/portal/app/routes'
import { CollapseButton } from '@piv/portal/primitives/Buttons'
import { DataFromDate } from '@piv/portal/primitives/DataFromDate'
import { DetailTable } from '@piv/portal/primitives/DetailTable'

export interface Props {
  dataPackageId: string
  subAssetId: string
}

export function DrilldownHeader({ dataPackageId, subAssetId }: Props) {
  const detail = DataPackages.useDataPackageDetail(dataPackageId, subAssetId)
  const location = useLocation()
  const [isExpanded, setIsExpanded] = useState(false)
  const subAssetName = detail.data?.subAsset?.displayName
  useTitle(subAssetName ? `${subAssetName} Records` : 'Sub Asset Records')

  return (
    <Stack gap={2}>
      <Breadcrumb>
        <h5>
          <Link to={location.state?.from || Routes.Explore.Home}>Explore</Link>
        </h5>
        <h5>
          {detail.isPending ? (
            <Spinner animation="border" size="sm" />
          ) : (
            <strong> {detail.data?.dataPackage.displayName}</strong>
          )}
        </h5>
        <h5>
          {detail.isPending ? (
            <Spinner animation="border" size="sm" />
          ) : (
            <> {detail.data?.subAsset.displayName}</>
          )}
        </h5>
      </Breadcrumb>

      <DetailTable
        title={
          <ExpandButtonContainer>
            <CollapseButton
              onClick={() => setIsExpanded((isExpanded) => !isExpanded)}
              isExpanded={isExpanded}
            >
              Summary
            </CollapseButton>
          </ExpandButtonContainer>
        }
        style={{ marginLeft: '1rem' }}
        id="summary-data"
      >
        {isExpanded && (
          <React.Fragment>
            <DetailTable.Item
              label="Data back to"
              value={
                <DataFromDate
                  date={detail.data?.metaData.dateFrom ?? null}
                  renderDataWarning={(date) => date >= new Date(2020, 0)}
                />
              }
            />
            <DetailTable.Item
              label="Brands"
              value={detail.data?.metaData.brandNames}
            />
            <DetailTable.Item
              label="Regions"
              value={detail.data?.metaData.regionNames}
            />
          </React.Fragment>
        )}
        <DetailTable.Item
          label="Currencies"
          value={detail.data?.metaData.currencyNames}
        />
      </DetailTable>
    </Stack>
  )
}

const ExpandButtonContainer = styled.div`
  background-color: #fff;
`

const Breadcrumb = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  > * {
    margin: 0;
    margin-right: 0.25rem;
  }

  > :not(:first-child) {
    ::before {
      content: ' - ';
    }
  }
`
